import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import PasswordRecovery, { PasswordRecoveryProps } from './PasswordRecovery.component';
import { RootState } from 'src/reducers/RootReducer';
import Authentication from 'src/value-objects/Authentication';
import { 
  passwordRecovery,
  PasswordRecoveryAction,
  passwordRecoveryClearErrors
} from 'src/actions/authentication/password-recovery/PasswordRecovery.actions';
import * as types from 'src/actions/authentication/password-recovery/Types';
import { Action } from 'redux';
import { OpenModal, openModal } from 'src/actions/modal';
import LoginContainer from '../login/Login.container';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import PasswordRecoverySuccess from './PasswordRecoverySuccess.container';

interface StateProps {
  errorMessage: {};
}

interface DispatchProps {
  passwordRecovery: (recovery: {email: string}) => Promise<PasswordRecoveryAction>;
  passwordRecoveryClearErrors: () => PasswordRecoveryAction;
  openModal: (content: JSX.Element) => void;
}

interface Props extends StateProps, DispatchProps {
  modalRef?: Modal;
}

interface State {
  email: string;
}
class PasswordRecoveryContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.props.passwordRecoveryClearErrors();
    this.state = {
      email: '',
    };
  }

  public render(): React.ReactNode {
    return <PasswordRecovery {...this.getComponentProps()}/>;
  }

  private handleChange(key: string): (value: string | boolean) => void {
    return (value: string | boolean) => {
      const newState = {};
      newState[key] = value;
      this.setState(newState);
    };
  }

  private handleSubmit(): void {

    this.props.passwordRecovery(this.state).then((response: Action) => {
      if (response.type === types.PASSWORD_RECOVERY_SUCCESS) {
        this.props.openModal(<PasswordRecoverySuccess/>);
      }
    });
  }

  private login(): void {
    this.props.openModal(
      <LoginContainer/>
    );
  }

  private getComponentProps(): PasswordRecoveryProps {
    return {
      handleChange: (key: string) => this.handleChange(key),
      handleSubmit: () => this.handleSubmit(),
      login: () => this.login(),
      errorMessage: this.props.errorMessage,
      modalRef: this.props.modalRef!,
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    passwordRecovery: (credentials: Authentication): Promise<PasswordRecoveryAction> => {
      return dispatch(passwordRecovery(credentials));
    },
    passwordRecoveryClearErrors: (): PasswordRecoveryAction => {
      return dispatch(passwordRecoveryClearErrors());
    },
    openModal: (content: JSX.Element): OpenModal => {
      return dispatch(openModal(content));
    }
  };
};

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  errorMessage: state.authentication.passwordRecoveryError,
});

export default connect(mapStateToProps, mapDispatchToProps)(PasswordRecoveryContainer);



// WEBPACK FOOTER //
// ./src/modules/modals/password-recovery/PasswordRecovery.container.tsx